import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ELEMENTS, ElementType } from '../utils/baziData';
export const FiveElementsCircle: React.FC = () => {
  const [activeElement, setActiveElement] = useState<ElementType | null>(null);
  const elements: {
    id: ElementType;
    angle: number;
  }[] = [{
    id: 'wood',
    angle: -18
  }, {
    id: 'fire',
    angle: 54
  }, {
    id: 'earth',
    angle: 126
  }, {
    id: 'metal',
    angle: 198
  }, {
    id: 'water',
    angle: 270
  }];
  const radius = 140; // Increased radius to prevent overlap
  return <div className="flex flex-col items-center" data-id="element-31">
      <div className="relative w-[360px] h-[360px] flex items-center justify-center" data-id="element-32">
        <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="-180 -180 360 360" data-id="element-33">
          <defs data-id="element-34">
            <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="9" refY="3.5" orient="auto" data-id="element-35">
              <polygon points="0 0, 10 3.5, 0 7" fill="rgba(184,134,11,0.4)" data-id="element-36" />
            </marker>
            <marker id="arrowhead-active" markerWidth="10" markerHeight="7" refX="9" refY="3.5" orient="auto" data-id="element-37">
              <polygon points="0 0, 10 3.5, 0 7" fill="#b8860b" data-id="element-38" />
            </marker>
          </defs>

          {/* Generating Cycle (Outer Circle) */}
          {elements.map((el, i) => {
          const next = elements[(i + 1) % 5];
          const isActive = activeElement === el.id;
          const startAngle = (el.angle + 22) * (Math.PI / 180);
          const endAngle = (next.angle - 22) * (Math.PI / 180);
          const x1 = Math.cos(startAngle) * radius;
          const y1 = Math.sin(startAngle) * radius;
          const x2 = Math.cos(endAngle) * radius;
          const y2 = Math.sin(endAngle) * radius;
          return <path key={`gen-${el.id}`} d={`M ${x1} ${y1} Q 0 0 ${x2} ${y2}`} fill="none" stroke={isActive ? '#b8860b' : 'rgba(184,134,11,0.2)'} strokeWidth={isActive ? 3 : 1.5} strokeDasharray="4 4" markerEnd={`url(#${isActive ? 'arrowhead-active' : 'arrowhead'})`} className="transition-all duration-300" data-id="element-39" />;
        })}

          {/* Controlling Cycle (Inner Star) */}
          {elements.map((el, i) => {
          const targetIdx = (i + 2) % 5;
          const target = elements[targetIdx];
          const isActive = activeElement === el.id;
          const startAngle = el.angle * (Math.PI / 180);
          const endAngle = target.angle * (Math.PI / 180);
          // Connect from inner edge of buttons
          const x1 = Math.cos(startAngle) * (radius - 35);
          const y1 = Math.sin(startAngle) * (radius - 35);
          const x2 = Math.cos(endAngle) * (radius - 35);
          const y2 = Math.sin(endAngle) * (radius - 35);
          return <line key={`ctrl-${el.id}`} x1={x1} y1={y1} x2={x2} y2={y2} stroke={isActive ? '#c94043' : 'rgba(201,64,67,0.2)'} strokeWidth={isActive ? 2 : 1} className="transition-all duration-300" data-id="element-40" />;
        })}
        </svg>

        {/* Element Nodes */}
        {elements.map(el => {
        const x = Math.cos(el.angle * (Math.PI / 180)) * radius;
        const y = Math.sin(el.angle * (Math.PI / 180)) * radius;
        const isActive = activeElement === el.id;
        return <motion.button key={el.id} className={`absolute w-16 h-16 rounded-full flex items-center justify-center text-2xl font-serif font-bold border-2 transition-all duration-300 z-10 bg-white
                ${isActive ? 'scale-110 shadow-md' : 'hover:scale-105 shadow-sm'}`} style={{
          transform: `translate(calc(${x}px - 50%), calc(${y}px - 50%))`,
          borderColor: `var(--color-element-${el.id})`,
          color: `var(--color-element-${el.id})`,
          backgroundColor: `color-mix(in srgb, var(--color-element-${el.id}) ${isActive ? '15%' : '5%'}, white)`
        }} onClick={() => setActiveElement(isActive ? null : el.id)} whileHover={{
          scale: 1.1
        }} whileTap={{
          scale: 0.95
        }} data-id="element-41">
              {ELEMENTS[el.id].name}
            </motion.button>;
      })}
      </div>

      {/* Info Display moved below to prevent overlap with inner star */}
      <div className="h-20 mt-4 flex items-center justify-center text-center" data-id="element-42">
        {activeElement ? <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white px-6 py-3 rounded-full shadow-sm border border-gold/20" data-id="element-43">
            <div className="text-gold-dark font-serif text-lg font-bold mb-1" data-id="element-44">
              {ELEMENTS[activeElement].name}
            </div>
            <div className="text-sm text-ink-light flex gap-4" data-id="element-45">
              <span data-id="element-46">
                <strong className="text-jade" data-id="element-47">生</strong>{' '}
                {ELEMENTS[ELEMENTS[activeElement].generates].name}
              </span>
              <span data-id="element-48">
                <strong className="text-cinnabar" data-id="element-49">克</strong>{' '}
                {ELEMENTS[ELEMENTS[activeElement].controls].name}
              </span>
            </div>
          </motion.div> : <div className="text-ink-light/50 font-serif text-sm bg-white/50 px-4 py-2 rounded-full" data-id="element-50">
            点击上方五行，查看生克关系
          </div>}
      </div>
    </div>;
};